<template>
  <div class>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Add Document</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="doc.title"
              v-model="doc.title"
              label="Document Title"
              type="text"
            ></v-text-field>
            <v-textarea
              v-model="doc.description"
              label="Description"
              hint="Enter a description for this group"
            ></v-textarea>
            <vue-dropzone
              id="dropzone"
              :awss3="awss3"
              :options="dropzoneOptions"
              @:vdropzone-s3-upload-error="s3UploadError"
              @:vdropzone-s3-upload-success="s3UploadSuccess"
              @:vdropzone-success="uploadSuccess"
            ></vue-dropzone>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="100">
      <v-flex px-4 py-4 text-xs-right>
        <v-btn @click="closePanel">Cancel</v-btn>
        <v-btn @click="addDocument">Add Document</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import vueDropzone from "vue2-dropzone";
import dropzoneConfig from "@/utils/dropzone.js";
import awss3Config from "@/utils/awsS3.js";
import courseAPI from "@/api/course.js";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "AddDocument",
  components: {
    vueDropzone
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data: () => ({
    doc: {},
    messages: {},
    loading: false,
    dropzoneOptions: dropzoneConfig,
    awss3: awss3Config,
    successMessage: "External Training Successfully Added.",
    errorMessage:
      "Oops, something went wrong! Please check information is correct.",
    s3ErrorMessage: "File upload error"
  }),
  mounted() {
    this.awss3.params.type = "aicc";
    this.awss3.params.course_id = this.id;
    this.doc.courseId = this.id;
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addDocument() {
      this.loading = true;
      courseAPI
        .addDocument(this.doc)
        .then(resp => {
          this.closePanel();
          EventBus.$emit("ASSET_ADDED", resp);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    uploadSuccess(file, object) {
      this.doc.file = object.data.id;
    },
    removeFile() {},
    s3UploadError() {
      this.$snotify.error(this.s3ErrorMessage);
    }
  }
};
</script>
